import React from 'react'
import { useTranslation } from 'react-i18next'

// The playbooks that take a booking: a half-filled one expires after this many hours of silence.
const BOOKING_TYPES = ['table_booking', 'appointment', 'order_pickup_delivery']
const DEFAULT_TIMEOUT_HOURS = 24
const MAX_TIMEOUT_HOURS = 720

export default function PoliciesCard({ playbook, canWrite, onChange }) {
  const { t } = useTranslation()
  const value = playbook.policies_text ?? ''
  const max = 1500
  const timeout = playbook.booking_timeout_hours ?? DEFAULT_TIMEOUT_HOURS
  const setTimeoutHours = (raw) => {
    if (raw === '') return
    const hours = Math.min(MAX_TIMEOUT_HOURS, Math.max(0, Math.trunc(Number(raw)) || 0))
    onChange?.({ booking_timeout_hours: hours })
  }
  return (
    <section className="rounded-xl border border-slate-200 bg-white p-5">
      <div className="flex items-baseline justify-between gap-2"><h2 className="text-base font-semibold">{t('playbook.cards.policies')}</h2><span className="font-mono text-xs text-slate-500">{value.length}/{max}</span></div>
      <textarea aria-label={t('playbook.fields.policies')} rows={4} maxLength={max} value={value} disabled={!canWrite} onChange={(event) => onChange?.({ policies_text: event.target.value })} className="mt-3 w-full rounded-lg border border-slate-300 p-2 text-sm" />
      {BOOKING_TYPES.includes(playbook.type) && (
        <div className="mt-4">
          <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
            {t('playbook.fields.bookingTimeout')}
            <input type="number" min={0} max={MAX_TIMEOUT_HOURS} step={1} value={timeout} disabled={!canWrite} onChange={(event) => setTimeoutHours(event.target.value)} className="w-24 rounded-lg border border-slate-300 p-2 text-sm" />
          </label>
          <p className="mt-1 text-xs text-slate-500">{t('playbook.fields.bookingTimeoutHint')}</p>
        </div>
      )}
    </section>
  )
}
